// actions/employee-onboarding/tickets.js

import { attachAuth } from '../../utils/authService';

export function ticketsHasErrored(bool) {
  return {
    type: 'ONBOARDING_TICKETS_HAS_ERRORED',
    hasErrored: bool
  };
}

export function ticketsIsLoading(bool) {
  return {
    type: 'ONBOARDING_TICKETS_IS_LOADING',
    isLoading: bool
  };
}

export function ticketsFetchDataSuccess(list) {
  return {
    type: 'ONBOARDING_TICKETS_FETCH_DATA_SUCCESS',
    list
  };
}

export function ticketsFetchData(host) {
  return (dispatch) => {
    dispatch(ticketsIsLoading(true));
    dispatch(ticketsHasErrored(false));
    fetch(host + 'admin/tickets', {
      method: 'get',
      headers: attachAuth()
    })
    .then(promise => {
      if (!promise.ok) {
        throw Error(promise.statusText);
      }
        
      promise.json()
        .then(result => {
          dispatch(ticketsFetchDataSuccess(result));
          dispatch(ticketsHasErrored(false));
          dispatch(ticketsIsLoading(false));
        })
        .catch((ex) => {
          console.log(ex);
          dispatch(ticketsHasErrored(true));
          dispatch(ticketsIsLoading(false));
        })
    })
    .catch((ex) => {
      console.log(ex);
      dispatch(ticketsHasErrored(true));
      dispatch(ticketsIsLoading(false));
    });
  };
}